/**
 * Constants for Alkymation (Workflow Automation System)
 */

// Trigger template IDs
export const TRIGGER_TEMPLATES = {
  WEBHOOK_SCREENING_COMPLETE: 'webhook-screening-complete',
};

export const EVALUATION_TEMPLATES = {
  ASSESSMENT_INVITATION: 'assessmentInvitation',
};

// Trigger configuration
export const TRIGGER_CONFIGS = {
  [TRIGGER_TEMPLATES.WEBHOOK_SCREENING_COMPLETE]: {
    name: 'Screening Complete Webhook',
    dynamicParameter: 'screeningId',
    requiresSelection: true,
    selectionType: 'screening',
    fetchFunction: 'getAllCustomSearchs',
    filterActive: true,
  },
};

// Node categories
export const NODE_CATEGORIES = {
  TRIGGER: 'WORKFLOW_NODE_CATEGORY_TRIGGER',
  LOGIC: 'WORKFLOW_NODE_CATEGORY_LOGIC',
  PROCESSING: 'WORKFLOW_NODE_CATEGORY_PROCESSING',
  EVALUATION: 'WORKFLOW_NODE_CATEGORY_EVALUATIONS',
};

// Validation messages
export const WORKFLOW_VALIDATION = {
  TRIGGER_REQUIRED: 'El workflow debe tener al menos un nodo trigger',
  SCREENING_REQUIRED: 'Debe seleccionar una evaluación para este trigger',
  NAME_REQUIRED: 'El nombre del workflow es requerido',
  INVALID_CONNECTION: 'Conexión inválida entre nodos',
};

// Utility functions
export const isScreeningRelatedTemplate = ({ node, exclude = undefined }) => {
  let validTemplates = [
    TRIGGER_TEMPLATES.WEBHOOK_SCREENING_COMPLETE,
    EVALUATION_TEMPLATES.ASSESSMENT_INVITATION,
  ];

  if (exclude) {
    validTemplates = validTemplates.filter((template) => template !== exclude);
  }

  const templateId = node?.template?.templateId ?? node?.templateId;
  return validTemplates.includes(templateId);
};

export default {
  TRIGGER_TEMPLATES,
  EVALUATION_TEMPLATES,
  TRIGGER_CONFIGS,
  NODE_CATEGORIES,
  WORKFLOW_VALIDATION,
  isScreeningRelatedTemplate,
};
